/** @jsx jsx */
import { Global, css, jsx } from "@emotion/core";
import PropTypes from "prop-types";
import React from "react";
import theme from "../styles";
// containers
import InsiderLinkWithActiveOverride from "../containers/InsiderLinkWithOverrideWithSubscription";
// helpers
import { CLEVERTAP_ACTIONS, EVENT_CATEGORIES, GA_ACTIONS, GENERAL_ACTIONS, HIT_TYPES } from "../helpers/constants";
import { timeToggleLink, timeToggleList, timeToggleListItem, timeToggleListItemHeader } from "../styles/toggleFilterStyles";
const sendGAEvent = (title, categoryName) => {
    window.ga &&
        ga(GENERAL_ACTIONS.SEND, {
            hitType: HIT_TYPES.EVENT,
            eventCategory: EVENT_CATEGORIES.FILTER,
            eventAction: GA_ACTIONS.TIME_FILTER,
            eventLabel: title,
            eventValue: categoryName
        });
};
const TimeBasedLinks = ({ links, location, showFilter, typeName: categoryName, doExactMatch = false, doAutoLinkActivation }) => {
    if (showFilter && showFilter.size) {
        return (<ul css={css(timeToggleList)}>
				<li css={css([timeToggleListItem, timeToggleListItemHeader])}>time:</li>
				{links.map(link => {
                return (<li css={css(timeToggleListItem)} key={link.href}>
							<InsiderLinkWithActiveOverride activeClassName="active" activeOverride={true} css={css(timeToggleLink)} href={link.href} matchWithoutQueryParams={true} doExactMatch={doExactMatch} onClick={() => sendGAEvent(link.title, categoryName)} doAutoLinkActivation={doAutoLinkActivation}>
								{link.title}
							</InsiderLinkWithActiveOverride>
						</li>);
            })}
			</ul>);
    }
    return null;
};
TimeBasedLinks.propTypes = {
    links: PropTypes.object,
    location: PropTypes.object.isRequired,
    showFilter: PropTypes.object,
    doExactMatch: PropTypes.bool
};
export default TimeBasedLinks;
